import { IIconsProps } from "components/Icons/icons.model";

const ConfiguracaoIcon = (props: IIconsProps) => (
  <img
    id={props.id}
    src={"/icon/menu/configuracoes.svg"}
    alt=""
    style={{ width: props.fontSize, height: props.fontSize }}
  />
);

export default ConfiguracaoIcon;
